import { defineStore } from 'pinia';

export const useFloatingContentStore = defineStore('floatingContent', {
    actions: {
        newContentShown(guid) {},
    },
});